import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab, Box } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import CompanyTabs from "./CompanyTabs";
import CreditCardOutlined from "@mui/icons-material/CreditCardOutlined";
import IconText from "components/lib-ui/IconContent";
import GeneralUtitilityService from "services/GeneralUtilityService";

export const Tabs = ({ sx: parentStyles }) => {
    const { hash } = useLocation();
    const navigate = useNavigate();
    const getTabFromUrl = hash ? hash.split("#")[1] : null;
    const [activeTab, setActiveTab] = useState(getTabFromUrl || "Subscriptions-and-credits");


    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
        navigate(`#${newValue}`);
    };

    const candidateTabsContent = [
        {
            value: GeneralUtitilityService.replaceSpacesWithHyphens("Subscriptions and credits"),
            label: (
                <IconText
                    icon={CreditCardOutlined}
                    text="Subscriptions and credits"
                    typographyStyles={{ fontSize: "1rem", fontWeight: "500" }}
                />
            ),
            component: <CompanyTabs />,
        }
    ];

    return (
        <Box
            sx={{
                background: "inherit",
                ...parentStyles,
            }}
        >
            <TabContext value={`${activeTab}`}>
                <Box
                    px={4}
                    sx={{
                        background: "white",
                        width: "100%",
                    }}
                >
                    <TabList
                        variant="scrollable"
                        onChange={handleChange}
                        aria-label="Company tabs"
                    >
                        {candidateTabsContent.map((item, index) => {
                            return (
                                <Tab
                                    sx={{
                                        textTransform: "none",
                                        fontSize: "1rem",
                                        fontWeight: "500",
                                    }}
                                    key={index}
                                    value={`${item.value}`}
                                    label={item.label}
                                />
                            );
                        })}
                    </TabList>
                </Box>

                <Divider />

                <Box
                    sx={{
                        height: "100%",
                        minHeight: "60vh",
                        width: "100%",
                        backgroundColor: "#F8F8F8",
                    }}
                >
                    {candidateTabsContent.map((item, index) => {
                        return (
                            <TabPanel key={index} value={`${item.value}`}>
                                {React.cloneElement(item.component, {
                                    activeTab: item.value,
                                })}
                            </TabPanel>
                        );
                    })}
                </Box>
            </TabContext>
        </Box>
    );
};

export default Tabs;
